// Infinite scroll on collection page
class CollectionInfiniteScroll {
  constructor() {
    this.selectors = {
      button: '[data-loadmore-button]',
      buttonSpinner: '.loading-overlay__spinner',
      container: '#product-grid',
      card: '#product-grid .grid__item',
      paginationWrapper: '.pagination-wrapper'
    }

    this.InfiniteSroll;
    this.addEventListeners();
    this.renderInfiniteScroll();
  }

  addEventListeners() {
    const self = this;
    document.addEventListener('facets-update:start', function() {
      self.destroyInfiniteScroll();
    });

    document.addEventListener('facets-update:end', function() {
      self.renderInfiniteScroll();
    });
  }

  renderInfiniteScroll() {
    const self = this;
    const loadMoreButton = document.querySelector(self.selectors.button);
    if (loadMoreButton) {
      const container = document.querySelector(self.selectors.container);
      this.InfiniteScroll = new InfiniteScroll(container, {
        path: window.location.pathname + "?page={{#}}&section_id=" + container.getAttribute('data-id'),
        append: self.selectors.card,
        checkLastPage: self.selectors.button,
        prefill: true,
        scrollThreshold: 800,
        history: false,
      })
    
      this.InfiniteScroll.on( 'request', function() {
        loadMoreButton.classList.add('loading');
        loadMoreButton.querySelector(self.selectors.buttonSpinner).classList.remove('hidden');
      });
    
      this.InfiniteScroll.on( 'append', function() {
        loadMoreButton.classList.remove('loading');
        loadMoreButton.querySelector(self.selectors.buttonSpinner).classList.add('hidden');
        // displatch event to convert money
        document.dispatchEvent(new Event('currency:convert'));
      });
    
      this.InfiniteScroll.on( 'last', function() {
        loadMoreButton.style.display = 'none';
      });
    }
  }

  destroyInfiniteScroll() {
    const self = this;
    if (self.InfiniteScroll) {
      self.InfiniteScroll.destroy();
    }
  }

}
new CollectionInfiniteScroll();